/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

import {Schema} from 'prosemirror-model';
import marks from './marks';
import nodes from './nodes';

const schema = new Schema({
    marks,
    nodes
});

export {schema, marks, nodes};
